import React from "react";
import { Menu } from "lucide-react";
import { Button, IconButton } from "../../Ui/index.jsx";
import { NotificationBell } from "./NotificationBell.jsx";
import { ThemeToggle } from "./ThemeToggle.jsx";

// A refused request (403) is the page model doing its job, not a connection problem, so only real failures count.
const CONNECTION_FAULTS = 10;

// The bar above every page: where you are, the sync state, the theme, the bell and your name (which opens your profile).
// Sign-out lives one click in, on the profile page: a bare logout arrow up here was a trap for one stray click.
export function Topbar({ me, title, name, onProfile, profileActive, loading, errors, notifications, navigate, reload, onOpenMenu }) {
  const faults = errors.filter((e) => e.status !== 401 && e.status !== 403).length;
  const initials = name.split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase();
  return (
    <header className="Atg-Topbar">
      <IconButton className="Atg-Mobile-Menu-Btn" label="Open menu" onClick={onOpenMenu}><Menu size={20} /></IconButton>
      <div className="Atg-Topbar-Title">
        <span className="crumb">{me?.company?.displayName || me?.activeTenant?.name || "Intranet"}</span>
        <span className="sep" aria-hidden="true">/</span>
        <strong>{title}</strong>
      </div>
      <div className="Atg-Topbar-Actions">
        {loading && <span className="Sync-Badge">Syncing</span>}
        {!loading && faults >= CONNECTION_FAULTS && <span className="Sync-Badge-Danger">Connection issues</span>}
        <ThemeToggle />
        <NotificationBell notifications={notifications} navigate={navigate} reload={reload} />
        {name && (
          <Button variant="ghost" className={"Atg-User-Chip" + (profileActive ? " Active" : "")} title="Your profile" onClick={onProfile}>
            <span className="Chip-Avatar">{initials}</span>
            <b>{name}</b>
          </Button>
        )}
      </div>
    </header>
  );
}
